import { render, staticRenderFns } from "./LayoutTagTitle.vue?vue&type=template&id=90231a2c&lang=pug&"
import script from "./LayoutTagTitle.vue?vue&type=script&lang=js&"
export * from "./LayoutTagTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports